module.exports = {
    trackMyOrderDeliveryMethod: {
        notretrieved: 'NotRetrieved',
        delivery: 'Delivery',
        pickup: 'Pickup',
        express: 'Express',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/track-my-order-deliverymethod.js